import React from 'react'
import { useId } from 'react';
import { CheckboxWrapper } from './style';

function Checkbox({label="",key="",name="",value="",onChange=()=>{},checked,className=""}) {
    const id = useId();
  return (
    <CheckboxWrapper key={key} className={className}>
         <label htmlFor={`${id}-input`}>
            <input type="checkbox" name={name} id={`${id}-input`} value={value} onChange={onChange} checked={checked} />
            <span>{label}</span>

         </label>
        
    </CheckboxWrapper>
  )
}

export default Checkbox;